export const validators = {
    regularValidator: /^[0-9a-zA-Z.-]+$/,
    priceValidator: /^[0-9.]+$/,
    digitValidator: /^[0-9]+$/,
    numberValidator: /^[0-9.,]*$/,
};